import Vue from 'vue';
import { APIHelper } from '@archistarai/auth-frontend';
export default {
  namespaced: true,
  state: {
    invoices: [],
    currentEditSubscription: null,
    status: [
      'Actioned',
      'Draft',
      'Sent',
      'Pending',
      'Partially Paid',
      'Paid',
      'Refunded',
      'Written Off',
      'Voided',
      'Payment Failed'
    ]
  },
  getters: {
    invoiceWhereUser(state) {
      return (guid) => state.invoices.filter((s) => s.userGuid === guid);
    },
    invoiceFind(state) {
      return (guid) => state.invoices.find((s) => s.invoice_guid === guid);
    },
    userInArrearsAmount(state) {
      return (guid) =>
        state.invoices
          .filter((s) => s.userGuid === guid)
          .filter((i) => i.status === 'Payment Failed')
          .map((i) => parseFloat(i['sub_total']))
          .reduce((a, b) => a + b, 0);
    }
  },
  mutations: {
    SET_OBJECT(state, { key, value }) {
      state[key] = value;
    },
    ADD_INVOICES(state, { invoices, force }) {
      if (force) state.invoices = invoices;
      invoices.forEach((invoice) => {
        const index = state.invoices.findIndex((s) => s.invoice_guid === invoice.invoice_guid);
        if (index >= 0) {
          // replace existing invoice
          Vue.set(state.invoices, index, invoice);
        } else {
          // not in list
          state.invoices.push(invoice);
        }
      });
    },
    ADD_INVOICE(state, invoice) {
      const index = state.invoices.findIndex((s) => s.invoice_guid === invoice.invoice_guid);
      if (index >= 0) {
        // replace existing invoice
        Vue.set(state.invoices, index, invoice);
      } else {
        // not in list
        state.invoices.push(invoice);
      }
    },
    REMOVE_INVOICE(state, guid) {
      const index = state.invoices.findIndex((s) => s.invoice_guid === guid);
      if (index >= 0) {
        state.invoices.splice(index, 1);
      }
    },
    SET_CURRENT_EDIT_INVOICE(state, invoice) {
      if (!invoice) {
        state.currentEditSubscription = null;
        return;
      }
      state.currentEditInvoice = invoice;
    }
  },
  actions: {
    async getInvoicesForUser({ state, commit }, { guid, force = false }) {
      if (!force && state.invoices.some((s) => s.userGuid === guid)) {
        //check if already have features
        return state.invoices.filter((s) => s.userGuid === guid);
      }
      try {
        const {
          data: { data: invoices }
        } = await APIHelper.AdminAPI.get(`/invoices?scope=user&guid=${guid}`);
        commit('ADD_INVOICES', { invoices, force });
        return invoices;
      } catch (e) {
        throw e;
      }
    },
    async getInvoiceForUser({ commit }, guid) {
      try {
        const {
          data: { data: invoice }
        } = await APIHelper.AdminAPI.get(`/invoices/${guid}`);
        commit('ADD_INVOICE', invoice);
        return invoice;
      } catch (e) {
        throw e;
      }
    }
  }
};
